import { ReactElement, useCallback } from 'react'
import { ReactComponent as ArrowDown } from './assets/arrow_down.svg'
import { ReactComponent as ArrowUp } from './assets/arrow_up.svg'
import { ReactComponent as Question } from './assets/question.svg'
import AccordionProps from './props'
import * as S from './styled'

export default function Accordion ({ children, className, index, isOpen = false, onOpen, title }: AccordionProps): ReactElement {
  const handleOpen = useCallback(() => {
    if (!isOpen) {
      onOpen(index)
      return
    }

    onOpen(undefined)
  }, [isOpen, onOpen, index])

  return <S.Container className={className}>
    <S.TopContainer onClick={handleOpen}>
      <S.TitleContainer>
        <Question />

        <S.Title className="title">{title}</S.Title>
      </S.TitleContainer>

      {isOpen ? <ArrowUp /> : <ArrowDown />}
    </S.TopContainer>

    {isOpen && children}
  </S.Container>
}
